<script setup>
import LottieIcon from '../../components/LottieIcon.vue';

const props = defineProps({
    authorbox: {
        type: Object,
        required: true,
    },
    user: {
        type: Object,
        required: true,
    },
});

const lottieFinanzjournalismus = () => import('../../components/icons/lottie-finanzjournalismus.json');
const lottieZielzonen = () => import('../../components/icons/lottie-praezise-zielzonen.json');
</script>

<template>
    <div class="group/author-preview overflow-hidden transition-all ease-in-out duration-300 mt-2">
        <router-link :to="'/hkcmnews/?authors=' + props.user.id">
            <div class="md:flex flex-col">
                <div class="md:shrink-0">
                    <img class="rounded-md object-cover object-top" :src="props.authorbox.portrait"
                        :alt="props.authorbox.author" />
                </div>
                <div class="uppercase tracking-wide text-sm font-semibold mt-4">
                    <div>{{ props.authorbox.author }}</div>
                </div>
                <div class="mt-4">
                    <div class="flex flex-wrap items-center gap-3">
                        <div class="flex gap-3 items-center">
                            <LottieIcon class="w-10 h-10" :animation-data="lottieFinanzjournalismus"
                                :loop-delay="5200" />
                            <div class="text-blue-dark">
                                <div class="text-lg font-semibold">{{ props.authorbox.publishedArticles }}</div>
                                <div class="text-xxs break-words">{{ $t('published_articles') }}</div>
                            </div>
                        </div>
                    </div>

                    <div v-if="props.authorbox.coreTopics.length > 0" class="mt-6">
                        <div class="flex items-center mb-3">
                            <LottieIcon class="w-10 h-10" :animation-data="lottieZielzonen" :loop-delay="5000" />
                            <div class="text-blue-dark">{{ $t('core_topics') }}</div>
                        </div>

                        <div class="flex flex-wrap items-center gap-3">
                            <div v-for="topic in props.authorbox.coreTopics"
                                class="rounded-full bg-blue-light flex items-center p-3 py-2 gap-2">
                                <span class="bg-blue w-3 h-3 rounded-full block"></span>
                                <span class="uppercase text-xxs">{{ topic }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </router-link>
    </div>
</template>
